import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IHyperlinkToSave } from "src/app/interfaces";
import { Setting } from "src/app/interfaces/helpTarget";
import { LogClass, Logger } from "src/app/logger";
import { NotificationFacade } from "src/app/notifications/services/notification.facade";
import { AbstractSettingsService } from "src/app/settings/abstractSettingsService";

@Component({
    selector: "admin-edit-setting",
    templateUrl: "./edit-setting.component.html",
    styleUrls: ["./../settings.component.scss"],
    standalone: false
})
@LogClass({ source: "EditSettingComponent" })
export class EditSettingComponent {
  @Output() public add = new EventEmitter<IHyperlinkToSave>();
  @Input() public settings: Setting[] = [];
  private logger: Logger;

  constructor(
    private settingsService: AbstractSettingsService,
    private notificationFacade: NotificationFacade
  ) {
    this.logger.debug("ctor");
  }

  public saveSetting(setting: Setting): void {
    this.settingsService.SaveSettingLink(setting).subscribe((ok) => {
      this.logger.info("saved:" + ok.default);
      this.notificationFacade.success("feedback_save_successful", 2000);
    });
  }
}
